import React from 'react';
import PropTypes from 'prop-types';
import './OrganizationChartReact.scss';
import { Icon } from '../../components';

const OrganizationNode = ({ node, onExpand, isExpanded }) => {
  const hasImage = node.imageUrl;
  const { isBusiness, isUser, hasChildren, childrenCount } = node;

  const handleExpandClick = e => {
    e.stopPropagation();
    if (hasChildren) {
      onExpand(node);
    }
  };

  return (
    <div className="org-node-wrapper">
      <div className={`org-node ${isUser ? 'is-user' : ''}`}>
        <div className="node-avatar-container">
          <span className="node-avatar">
            {hasImage ? (
              <img src={node.imageUrl} crossOrigin="use-credentials" alt={node.name} />
            ) : (
              <Icon icon="camera" />
            )}
          </span>
        </div>
        {!isBusiness && <div className="node-divider" />}
        {!isBusiness && <div className="node-title">{node.title || ''}</div>}
        <div className="node-name">{node.name}</div>
      </div>

      {hasChildren && childrenCount > 0 && (
        <div className="expand-button-container" aria-hidden="true" onClick={handleExpandClick}>
          <div className="expand-button">
            <span className="expand-count">{childrenCount}</span>
            <span className="expand-icon">
              <Icon width={15} icon={isExpanded ? 'chevron-up1' : 'chevron-down'} />
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

OrganizationNode.propTypes = {
  node: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    imageUrl: PropTypes.string,
    hasChildren: PropTypes.bool,
    _directSubordinates: PropTypes.number,
    isUser: PropTypes.bool,
    isBusiness: PropTypes.bool
  }).isRequired,
  onExpand: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool
};

OrganizationNode.defaultProps = {
  isExpanded: false
};

export default OrganizationNode;
